import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformResponseHandler } from 'utils/transformResponseHandler';

export const calendarApi = createApi({
    reducerPath: 'calendarApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_ROUTE}`,
        prepareHeaders: (headers, { getState }) => {
            const token = getState()?.posData?.token;
            if (token) {
                headers.set('Authorization', token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getCalendarData: builder.query({
            query: ({ date }) => {
                return {
                    url: `/pos/calendar?date=${date}`,
                    method: 'GET',
                }
            },
            // providesTags: ['UserList'],
            // transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        getTableTimeSlots: builder.query({
            query: ({ is_weekend, table_id, booking_date }) => {
                let url = `/pos/time-slots/table-slots?is_weekend=${is_weekend}`;
                if (table_id) url += `&table_id=${table_id}`;
                if (booking_date) url += `&booking_date=${booking_date}`;
                return {
                    url,
                    method: "GET",
                };
            },
            // providesTags: ["Categories"],
            transformErrorResponse: (error) => transformResponseHandler(error),
        }),
    }),
});

export const { useGetCalendarDataQuery, useGetTableTimeSlotsQuery } = calendarApi;